export default "/dist/files/img.110ebd6ed5c334477eca9200a1e0449b.svg";